module.exports = __webpack_public_path__ + "media/img/vca/sponsors/beautehub-bc96e663cee1b74823d479eaaba667f0.png";